interface ICodeName {
  code: string;
  name: string;
}

export const MOD_CODES_GROUP_ID = 'mod_codes';
export const MOD_SIZES_GROUP_ID = '_size';
export const GREETING_PREFIX = 'welcome';

export const UNIFIED_MENU_CODE_NAME_MAPPING: Record<string, ICodeName> = {
  '1': {
    code: '~',
    name: 'light',
  },
  '2': {
    code: '-',
    name: 'remove',
  },
  '3': {
    code: '++',
    name: 'extra',
  },
  '4': {
    code: '>>',
    name: 'onside',
  },
  '5': {
    code: '+',
    name: 'add',
  },
  '6': {
    code: '=',
    name: 'only',
  },
  '7': {
    code: '_',
    name: 'sub',
  },
};

export const UNIFIED_MENU_MOD_SYMBOL_MAPPING: Record<string, ICodeName> = {
  '~': {
    code: '1',
    name: 'light',
  },
  '-': {
    code: '2',
    name: 'remove',
  },
  '++': {
    code: '3',
    name: 'extra',
  },
  '>>': {
    code: '4',
    name: 'onside',
  },
  '+': {
    code: '5',
    name: 'add',
  },
  '=': {
    code: '6',
    name: 'only',
  },
  _: {
    code: '7',
    name: 'sub',
  },
  '.': {
    code: '0',
    name: 'dummy modCode',
  },
};

export const CONSTRAINT_ITEM_NOT_ON_CHECK = 'CONSTRAINT_ITEM_NOT_ON_CHECK';
export const DO_NOT_UPSELL_IN_EXPRESS_MODE = 'do_not_upsell_in_express_mode';
export const ALWAYS_OFFER = 'always_offer';
export const EXPRESS_MODE_MEAL_PERIOD_PREFIX = 'express mode';
export const GENERIC_CONSTRAINT_OPTIONS = ['decline', 'yes', 'no'];
export const BRACKET_PATTERN = /^([^\[]+)\[([^\]]*)]$/;

export const HITL_INTENT_PHRASE_CATEGORY = 'conversational_reply';
export const DISMISS_READBACK_UTTERANCE_NAME = 'Dismiss & Readback';
